import * as React from 'react';
import C from 'classnames';
import { Link } from 'react-router-dom';
export const BreadcrumbItem = ({ children, className, to, href, active }) => {
    return (React.createElement("li", { className: C(className, 'breadcrumb-item', active && 'active') }, to ? (React.createElement(Link, { className: C('breadcrumb-link'), to: to }, children)) : href ? (React.createElement("a", { className: C('breadcrumb-link'), href: href }, children)) : (React.createElement(React.Fragment, null, children))));
};
//# sourceMappingURL=BreadcrumbItem.js.map